<template>
  <section class="content">
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box">
          <!-- /.box-header -->
          <div class="box-body">
            <div class="row m-b-15">
              <div class="row center-block">
                <div class="col-md-12">
                  <div>
                    <br />
                    <div class="row fit gutter mx-auto">
                      <div class="col-md-6 gutter">
                        <div class="table-row">
                          <div class="table-cell">
                            <span>菜單名稱</span>
                          </div>
                          <div class="table-from">
                            <div class="form-control form-info">{{menuName}}</div>
                          </div>
                        </div>
                        <div class="table-row">
                          <div class="table-cell">
                            <span>菜單ID</span>
                          </div>
                          <div class="table-from">
                            <input class="form-control" placeholder="" type="text" v-model="menuId" maxlength="45" v-if="!$route.query.menu_id">
                            <div
                              v-else
                              class="form-control form-info"
                              v-text="menuId"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 gutter">
                        <div class="table-row">
                          <div class="table-cell">
                            <span class="text-red">＊ </span>上架時間
                          </div>
                          <div class="table-from">
                            <date-picker
                              v-model="menuTime.start.time"
                              class="hide-date-icon"
                              :show-second="false"
                              type="datetime"
                              valueType="format"
                              format="YYYY-MM-DD HH:mm:ss"
                              input-class="form-control"
                              :clearable="false"
                              :disabled-time="notBeforeTodayAddTwoMins"
                              :disabled-date="notBeforeToday"
                            />
                          </div>
                        </div>
                        <div>（更換菜單後請確認已接收預訂單是否受影響。）</div>
                      </div>
                      <!--
                        getRoleType 10 門市權限，
                        因為一帳號，預設取第一個門市值，當作唯一門市，不需要選擇門市功能
                      -->
                      <div
                        v-if="
                          this.getRoleType !== 10 &&
                          $route.name !== 'StoreMenuScheduleCreate'
                        "
                        class="col-xs-12"
                      >
                        <nd-multi-select-listbox
                          :brandId="brandId"
                          :getDataH="getDataH"
                          :storeId="storeId"
                          :type="1"
                          @update:choose="updateChoose"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
            <div class="box-footer text-center">
              <button class="btn btn-default" @click="$router.go(-1)">
                取消
              </button>
              <button class="btn btn-success" @click="crSchedule">
                新增
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// core
import { mapGetters } from 'vuex'

// utils
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu.vue'

// components
import storeListTemp from './Temp/StoreListTemp.vue'
import NdMultiSelectListbox from '@/components/elements/nd-multi-select-listbox.vue'

export default {
  name: 'CrSchedule',
  extends: NdExtendHandleMenu,
  components: {
    'storelist-table': storeListTemp,
    DatePicker,
    'nd-multi-select-listbox': NdMultiSelectListbox
  },
  data () {
    return {
      brandId: 0,
      content: {
        bindingStoreList: []
      },
      storeBrief: [],
      oldScheduleTime: '',
      scheduleTime: '',
      menuTime: {
        start: {
          time: moment().set('second', 0).add(5, 'm').format('YYYY-MM-DD HH:mm:ss')
        }
      },
      show: {
        back: false
      },
      tableIndex: 1,
      menuId: 0,
      menuName: '',
      storeId: 0,
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      info: {
        menuName: '夏日菜單',
        menu_id: 123323,
        start_time: '2017-03-31 12:22:32',
        end_time: '2017-03-31 12:22:32',
        update_time: '2017-03-31 12:22:32',
        create_time: '2017-03-31 12:22:32'
      },
      menu_schedule_list: [
        {
          'schedule_id': 122,
          'store_id': 1,
          'store_name': '金山店',
          'menu_id': 1,
          'start_time': '2017-07-24 08:00:00',
          'end_time': '2017-08-01 00:00:00',
          'status': 1,
          'update_time': '2017-01-14 16:09:16',
          'create_time': '2017-01-14 16:09:16'
        },
        {
          'schedule_id': 123,
          'store_id': 2,
          'store_name': '中山店',
          'menu_id': 2,
          'start_time': '2017-07-24 08:00:00',
          'end_time': '2017-08-01 00:00:00',
          'status': 1,
          'update_time': '2017-01-14 16:09:16',
          'create_time': '2017-01-14 16:09:16'
        }
      ],
      addStoresSetting: {
        class: 'add-store',
        options: [],
        choose: []
      },
      storeClassList: [],
      curId: 0,
      reNew: 0,
      reSet: 0
    }
  },
  mounted () {
    this.oldScheduleTime = this.scheduleTime = '2015-01-01 01:30:00 - 2015-01-02 01:30:00'

    if (this.$route.params.brand_id) {
      this.brandId = Number(this.$route.params.brand_id)
    }
    if (this.$route.params.store_id) {
      this.storeId = Number(this.$route.params.store_id)
    }
    if (this.$route.params.menu_id) {
      this.menuId = Number(this.$route.params.menu_id)
    }
    if (this.$route.query.menu_name) {
      this.menuName = this.$route.query.menu_name
    }

    // 相容性修正，store權限，用brand_id寫入storeId
    if (this.getRoleType === 10) {
      this.storeId = Number(this.$route.params.brand_id)
    } else {
      this.brandId = Number(this.$route.params.brand_id)
    }
  },
  methods: {
    notBeforeToday (date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0))
    },
    notBeforeTodayAddTwoMins (date) {
      return date < new Date(moment().set('second', 0).add(5, 'm').toString())
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    crSchedule () {
      if (moment() > moment(this.menuTime.start.time)) {
        this.$notify({
          title: '提醒',
          text: '上架時間逾時，請重新選擇。',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        return
      }

      let data = {
        store_id: [],
        menu_id: this.menuId,
        start_time: this.menuTime.start.time
      }

      this.addStoresSetting.choose.forEach((store) => {
        data.store_id.push(store)
      })

      const url = this.base + this.id + '/menu/schedule/group'

      this.getDataH('post', url, data, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '提醒',
            text: '新增菜單成功',
            duration: 3000,
            type: 'success',
            width: 400
          })

          let name = ''
          let params = {
            brand_id: this.$route.params.brand_id,
            store_id: ''
          }

          if (this.isStore && this.getRoleType !== 10) {
            name = 'StoreMenuSchedule'
            params.store_id = this.$route.params.store_id
          } else {
            name = 'brandScheduleTable'
          }

          this.$router.push({ name, params })
        }
      })
    },
    getStoreClassList () {
      let url = '/brand/' + this.$route.params.brand_id + '/storeClassList'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          const sList = response.data.list
          this.storeClassList = sList
        }
      })
    },
    updateChoose (val) {
      console.log('updateChoose', val)
      this.addStoresSetting.choose = val
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    scheduleListNew () {
      var menuList = {}
      var oldList = this.menu_schedule_list
      for (var key in oldList) {
        menuList[oldList[key].menu_id] = {
          menu_id: oldList[key].menu_id,
          storeList: []
        }
      }
      for (var k in oldList) {
        menuList[oldList[k].menu_id].storeList.push({
          store_id: oldList[k].store_id,
          store_name: oldList[k].store_name,
          start_time: oldList[k].start_time,
          end_time: oldList[k].end_time,
          status: oldList[k].status,
          update_time: oldList[k].update_time,
          create_time: oldList[k].create_time,
          schedule_id: oldList[k].schedule_id
        })
      }
      return menuList
    }
  }
}
</script>
<style lang="sass" scoped>
.input-group .form-control
  z-index: 1 !important
// .ranges
  display: none
.min-item.active, .hour-item.active, .day.checked
  background: #222d32 !important
.w-200
  width: 180px !important
.m-b-15
  margin-bottom: 15px !important
.btn-all-store
  position: absolute
  right: 10px
  z-index: 30
  top: 0px
.input-white
  border: 0px
@media screen and (max-width: 767px)
  .p-sm-10-p
    padding-right: 10px !important
    padding-left: 10px !important
@media screen and (min-width: 768px)
  .p-sm-10-p
    padding-right: calc(20% - 15px) !important
    padding-left: calc(20% + 10px) !important
@media screen and (min-width: 991px)
  .p-sm-10-p
    padding-right: calc(10% - 10px) !important
    padding-left: 10% !important
</style>
<style lang="sass">
  @media screen and (max-width: 767px)
    .input-group.cr-schedule .cov-vue-date .cov-datepicker
      width: calc(100vw - 185px)
  @media screen and (min-width: 768px)
    .input-group.cr-schedule .cov-vue-date .cov-datepicker
      width: calc(50vw - 190px)
  @media screen and (min-width: 991px)
    .input-group .cov-vue-date .cov-datepicker
      max-width: calc(30vw - 190px)
</style>



// WEBPACK FOOTER //
// CrSchedule.vue?5c3f4514